<template>
  <router-view />
</template>
<script setup>
import { onMounted } from 'vue';
import loadjs from 'loadjs';


onMounted(() => {
    // 日志打点初始化
    loadjs('//cnstatic01.e.vhall.com/common-static/middle/middle-log/1.0.7/index.min.js', {
      success: function() {
        window.vhallReportForProduct = new VhallReportForProduct({
            env: process.env.NODE_ENV === 'production' ? 'production' : 'test',
            t_start: dayjs().format('YYYY-MM-DD HH:mm:ss'),
            pf: 8, // 客户端类型  web 网页端用 8
          });
      }
    });
})
</script>
<style lang="scss">
@import url(@/assets/styles/index.scss);
#app {
  font-family: "Helvetica Neue", "Source Sans Pro", -apple-system,
    BlinkMacSystemFont, "Segoe UI", Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>
